import { canReturnEmail } from '@reown/web-wallet-core/src/utils/LoginProviderUtils'

import styles from './styles.module.css'

type PermissionItemProps = {
  icon: 'checkmark' | 'close'
  iconColor: 'success' | 'error'
  text: string
}

function PermissionItem({ icon, iconColor, text }: PermissionItemProps) {
  return (
    <div className={styles.permission}>
      <wui-icon size="md" color={iconColor} name={icon} />
      <wui-text variant="lg-regular" color="primary" align="left">
        {text}
      </wui-text>
    </div>
  )
}

export function Permissions({ provider }: { provider?: string }) {
  return (
    <div className={styles.container}>
      <wui-text variant="md-regular" color="secondary" align="left">
        Allow app to:
      </wui-text>
      <PermissionItem icon="checkmark" iconColor="success" text="See balance and activity" />
      {canReturnEmail(provider) && (
        <PermissionItem icon="checkmark" iconColor="success" text="See your email" />
      )}
      <PermissionItem icon="checkmark" iconColor="success" text="Send request for approval" />
      <PermissionItem
        icon="close"
        iconColor="error"
        text="Sign transactions without your approval"
      />
    </div>
  )
}
